<div *ngIf="stockCount">
  <div class="order-page-title" id="top">
    <eps-button class="edit-button" (buttonClick)="backClicked()" label="SHARED.BUTTONS.BACK"></eps-button>
    <div class="content">
      <div class="title">
        <app-title title="STOCK_COUNT.DETAIL.TITLE"></app-title>
        <span class="subtitle">{{ stockCount.stockCountNo }}</span>
      </div>
    </div>
  </div>
  <div class="row filter-container" *ngIf="stockCount">
    <div class="col-12 col-md-12 col-lg-9 filter-container-inner">
      <!-- GENERAL -->
      <div class="order-create-title-bar">
        <div class="row order-create-title-bar-header">
          <div class="order-create-title">
            <i class="fa fa-truck icon-label" aria-hidden="true"></i>
            {{ 'STOCK_COUNT.LABELS.GENERAL' | translate }}
          </div>
        </div>

        <div class="material-lines-panel">
          <div class="row align_center-md">
            <div class="col-12 col-md-2 form-label">
              <app-label translationCode="STOCK_COUNT.LABELS.REGISTRATION_NUMBER"></app-label>
            </div>
            <div class="col-12 col-md-10 general-label">
              {{ stockCount.stockCountNo }}
            </div>
          </div>

          <div class="row align_center-md">
            <div class="col-12 col-md-2 form-label">
              <app-label translationCode="STOCK_COUNT.LABELS.SHIPTO"></app-label>
            </div>
            <div class="col-12 col-md-10 general-label">
              {{ stockCount.shipTo }}
            </div>
          </div>

          <div class="row align_center-md">
            <div class="col-12 col-md-2 form-label">
              <app-label translationCode="STOCK_COUNT.LABELS.REMARKS"></app-label>
            </div>
            <div class="col-12 col-md-10 general-label">
              {{ stockCount.comments }}
            </div>
          </div>
        </div>
      </div>

      <!-- MATERIAL LINES -->
      <div class="order-create-title-bar">
        <div class="row order-create-title-bar-header">
          <div class="order-create-title">
            <i class="fa fa-file-o icon-label" aria-hidden="true"></i>
            {{ 'STOCK_COUNT.LABELS.FLOWLINES' | translate }}
          </div>
        </div>

        <div class="material-lines-panel" *ngIf="stockCount.items.length > 0">
          <h3>{{ 'STOCK_COUNT.LABELS.MATERIAL' | translate }}</h3>

          <!-- COLUMNS -->
          <div class="row cell headings hide-xs">
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.PACKING' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.COUNTED' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.COUNTED_BOOLEAN' | translate }}
            </div>
          </div>

          <div class="hr-accent no_margin_bottom hide-xs"></div>

          <div *ngFor="let p of stockCount.items" class="row striped readonly material_line">
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.PACKING' | translate }}: </span>
              {{ findPackingId(p) }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.COUNTED' | translate }}: </span>
              {{ p.notCounted ? '-' : p.amount }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.COUNTED_BOOLEAN' | translate }}: </span>
              <app-checkbox class="marginLeft" [value]="!p.notCounted" [readonly]="true"></app-checkbox>
            </div>
          </div>
        </div>
      </div>

      <!-- ORDERS -->
      <div class="order-create-title-bar">
        <div class="row order-create-title-bar-header">
          <div class="order-create-title">
            <i class="fa fa-calendar-check-o icon-label" aria-hidden="true"></i>
            {{ 'STOCK_COUNT.LABELS.ORDERS' | translate }}
          </div>
        </div>

        <div class="material-lines-panel" *ngIf="stockCount.orders.length > 0">
          <!-- COLUMNS -->
          <div class="row cell headings hide-xs">
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.ORDER' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.SALESORDER' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.FROM' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.TO' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.CUSTOMER' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.REQUESTEDDATE' | translate }}
            </div>
            <div class="col-md">
              {{ 'STOCK_COUNT.LABELS.COUNTED_INCLUDED' | translate }}
            </div>
          </div>

          <div class="hr-accent hide-xs no_margin_bottom"></div>

          <div *ngFor="let o of stockCount.orders" class="row striped readonly material_line">
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.ORDER' | translate }}: </span>
              {{ o.etmOrderNo }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only"> {{ 'STOCK_COUNT.LABELS.SALESORDER' | translate }}: </span>
              {{ o.salesOrderNo }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.FROM' | translate }}: </span>
              {{ mapToOrFrom(o.from) }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.TO' | translate }}: </span>
              {{ mapToOrFrom(o.to) }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.CUSTOMER' | translate }}: </span>
              {{ o.customerRefNo }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.REQUESTEDDATE' | translate }}: </span>
              {{ o.requestedDeliveryDate | date: dateFormat }}
            </div>
            <div class="col-md">
              <span class="bold mobile-only">{{ 'STOCK_COUNT.LABELS.COUNTED_INCLUDED' | translate }}: </span>
              <app-checkbox class="marginLeft" [value]="o.includedInCount" [readonly]="true"></app-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
